// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/metrics/v1/metrics.proto" (package "c1.api.metrics.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { App } from "../../app/v1/app";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.metrics.v1.MetricsServiceGetRequest
 */
export interface MetricsServiceGetRequest {
    /**
     * @generated from protobuf field: c1.api.metrics.v1.MetricType metric_type = 1
     */
    metricType: MetricType;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.MetricsServiceGetResponse
 */
export interface MetricsServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.metrics.v1.MetricView metric_view = 1
     */
    metricView?: MetricView;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.MetricRef
 */
export interface MetricRef {
    /**
     * @generated from protobuf field: c1.api.metrics.v1.MetricType metric_type = 1
     */
    metricType: MetricType;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.Metric
 */
export interface Metric {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: c1.api.metrics.v1.MetricType metric_type = 2
     */
    metricType: MetricType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp stale_at = 5
     */
    staleAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any value = 6
     */
    value?: Any;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.MetricView
 */
export interface MetricView {
    /**
     * @generated from protobuf field: c1.api.metrics.v1.Metric metric = 1
     */
    metric?: Metric;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.CountsByApp
 */
export interface CountsByApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.OrphanedAccountsMetric
 */
export interface OrphanedAccountsMetric {
    /**
     * @generated from protobuf field: int64 total_count = 1
     */
    totalCount: number;
    /**
     * @generated from protobuf field: repeated c1.api.metrics.v1.CountsByApp counts_by_app = 2
     */
    countsByApp: CountsByApp[];
}
/**
 * @generated from protobuf message c1.api.metrics.v1.InactiveAccountsMetric
 */
export interface InactiveAccountsMetric {
    /**
     * @generated from protobuf field: int64 total_count = 1
     */
    totalCount: number;
    /**
     * @generated from protobuf field: repeated c1.api.metrics.v1.CountsByApp counts_by_app = 2
     */
    countsByApp: CountsByApp[];
}
/**
 * @generated from protobuf message c1.api.metrics.v1.CountsByAppUserTypeMetric
 */
export interface CountsByAppUserTypeMetric {
    /**
     * @generated from protobuf field: int64 user_account_count = 1
     */
    userAccountCount: number;
    /**
     * @generated from protobuf field: int64 service_account_count = 2
     */
    serviceAccountCount: number;
    /**
     * @generated from protobuf field: int64 system_account_count = 3
     */
    systemAccountCount: number;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.YearInReviewMetricEntry
 */
export interface YearInReviewMetricEntry {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "intValue";
        /**
         * @generated from protobuf field: int64 int_value = 2
         */
        intValue: number;
    } | {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 3
         */
        stringValue: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.metrics.v1.GetYearInReviewRequest
 */
export interface GetYearInReviewRequest {
    /**
     * @generated from protobuf field: string year = 1
     */
    year: string;
}
/**
 * @generated from protobuf message c1.api.metrics.v1.GetYearInReviewResponse
 */
export interface GetYearInReviewResponse {
    /**
     * @generated from protobuf field: repeated c1.api.metrics.v1.YearInReviewMetricEntry metrics = 1
     */
    metrics: YearInReviewMetricEntry[];
}
/**
 * @generated from protobuf enum c1.api.metrics.v1.MetricType
 */
export enum MetricType {
    /**
     * @generated from protobuf enum value: METRIC_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: METRIC_TYPE_ORPHANED_ACCOUNTS = 1;
     */
    ORPHANED_ACCOUNTS = 1,
    /**
     * @generated from protobuf enum value: METRIC_TYPE_INACTIVE_ACCOUNTS = 2;
     */
    INACTIVE_ACCOUNTS = 2,
    /**
     * @generated from protobuf enum value: METRIC_TYPE_COUNTS_BY_ACCOUNT_TYPE = 3;
     */
    COUNTS_BY_ACCOUNT_TYPE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class MetricsServiceGetRequest$Type extends MessageType<MetricsServiceGetRequest> {
    constructor() {
        super("c1.api.metrics.v1.MetricsServiceGetRequest", [
            { no: 1, name: "metric_type", kind: "enum", T: () => ["c1.api.metrics.v1.MetricType", MetricType, "METRIC_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<MetricsServiceGetRequest>): MetricsServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricsServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricsServiceGetRequest): MetricsServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.metrics.v1.MetricType metric_type */ 1:
                    message.metricType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricsServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.metrics.v1.MetricType metric_type = 1; */
        if (message.metricType !== 0)
            writer.tag(1, WireType.Varint).int32(message.metricType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.MetricsServiceGetRequest
 */
export const MetricsServiceGetRequest = new MetricsServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricsServiceGetResponse$Type extends MessageType<MetricsServiceGetResponse> {
    constructor() {
        super("c1.api.metrics.v1.MetricsServiceGetResponse", [
            { no: 1, name: "metric_view", kind: "message", T: () => MetricView }
        ]);
    }
    create(value?: PartialMessage<MetricsServiceGetResponse>): MetricsServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MetricsServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricsServiceGetResponse): MetricsServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.metrics.v1.MetricView metric_view */ 1:
                    message.metricView = MetricView.internalBinaryRead(reader, reader.uint32(), options, message.metricView);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricsServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.metrics.v1.MetricView metric_view = 1; */
        if (message.metricView)
            MetricView.internalBinaryWrite(message.metricView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.MetricsServiceGetResponse
 */
export const MetricsServiceGetResponse = new MetricsServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricRef$Type extends MessageType<MetricRef> {
    constructor() {
        super("c1.api.metrics.v1.MetricRef", [
            { no: 1, name: "metric_type", kind: "enum", T: () => ["c1.api.metrics.v1.MetricType", MetricType, "METRIC_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<MetricRef>): MetricRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricRef): MetricRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.metrics.v1.MetricType metric_type */ 1:
                    message.metricType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.metrics.v1.MetricType metric_type = 1; */
        if (message.metricType !== 0)
            writer.tag(1, WireType.Varint).int32(message.metricType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.MetricRef
 */
export const MetricRef = new MetricRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Metric$Type extends MessageType<Metric> {
    constructor() {
        super("c1.api.metrics.v1.Metric", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "metric_type", kind: "enum", T: () => ["c1.api.metrics.v1.MetricType", MetricType, "METRIC_TYPE_"] },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "stale_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "value", kind: "message", T: () => Any }
        ]);
    }
    create(value?: PartialMessage<Metric>): Metric {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<Metric>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Metric): Metric {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* c1.api.metrics.v1.MetricType metric_type */ 2:
                    message.metricType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp stale_at */ 5:
                    message.staleAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.staleAt);
                    break;
                case /* google.protobuf.Any value */ 6:
                    message.value = Any.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Metric, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* c1.api.metrics.v1.MetricType metric_type = 2; */
        if (message.metricType !== 0)
            writer.tag(2, WireType.Varint).int32(message.metricType);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp stale_at = 5; */
        if (message.staleAt)
            Timestamp.internalBinaryWrite(message.staleAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Any value = 6; */
        if (message.value)
            Any.internalBinaryWrite(message.value, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.Metric
 */
export const Metric = new Metric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricView$Type extends MessageType<MetricView> {
    constructor() {
        super("c1.api.metrics.v1.MetricView", [
            { no: 1, name: "metric", kind: "message", T: () => Metric, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<MetricView>): MetricView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MetricView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricView): MetricView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.metrics.v1.Metric metric */ 1:
                    message.metric = Metric.internalBinaryRead(reader, reader.uint32(), options, message.metric);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.metrics.v1.Metric metric = 1; */
        if (message.metric)
            Metric.internalBinaryWrite(message.metric, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.MetricView
 */
export const MetricView = new MetricView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountsByApp$Type extends MessageType<CountsByApp> {
    constructor() {
        super("c1.api.metrics.v1.CountsByApp", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountsByApp>): CountsByApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountsByApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountsByApp): CountsByApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountsByApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.CountsByApp
 */
export const CountsByApp = new CountsByApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrphanedAccountsMetric$Type extends MessageType<OrphanedAccountsMetric> {
    constructor() {
        super("c1.api.metrics.v1.OrphanedAccountsMetric", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "counts_by_app", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CountsByApp }
        ]);
    }
    create(value?: PartialMessage<OrphanedAccountsMetric>): OrphanedAccountsMetric {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        message.countsByApp = [];
        if (value !== undefined)
            reflectionMergePartial<OrphanedAccountsMetric>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrphanedAccountsMetric): OrphanedAccountsMetric {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total_count */ 1:
                    message.totalCount = reader.int64().toNumber();
                    break;
                case /* repeated c1.api.metrics.v1.CountsByApp counts_by_app */ 2:
                    message.countsByApp.push(CountsByApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrphanedAccountsMetric, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total_count = 1; */
        if (message.totalCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.totalCount);
        /* repeated c1.api.metrics.v1.CountsByApp counts_by_app = 2; */
        for (let i = 0; i < message.countsByApp.length; i++)
            CountsByApp.internalBinaryWrite(message.countsByApp[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.OrphanedAccountsMetric
 */
export const OrphanedAccountsMetric = new OrphanedAccountsMetric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InactiveAccountsMetric$Type extends MessageType<InactiveAccountsMetric> {
    constructor() {
        super("c1.api.metrics.v1.InactiveAccountsMetric", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "counts_by_app", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CountsByApp }
        ]);
    }
    create(value?: PartialMessage<InactiveAccountsMetric>): InactiveAccountsMetric {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        message.countsByApp = [];
        if (value !== undefined)
            reflectionMergePartial<InactiveAccountsMetric>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InactiveAccountsMetric): InactiveAccountsMetric {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total_count */ 1:
                    message.totalCount = reader.int64().toNumber();
                    break;
                case /* repeated c1.api.metrics.v1.CountsByApp counts_by_app */ 2:
                    message.countsByApp.push(CountsByApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InactiveAccountsMetric, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total_count = 1; */
        if (message.totalCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.totalCount);
        /* repeated c1.api.metrics.v1.CountsByApp counts_by_app = 2; */
        for (let i = 0; i < message.countsByApp.length; i++)
            CountsByApp.internalBinaryWrite(message.countsByApp[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.InactiveAccountsMetric
 */
export const InactiveAccountsMetric = new InactiveAccountsMetric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountsByAppUserTypeMetric$Type extends MessageType<CountsByAppUserTypeMetric> {
    constructor() {
        super("c1.api.metrics.v1.CountsByAppUserTypeMetric", [
            { no: 1, name: "user_account_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "service_account_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "system_account_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountsByAppUserTypeMetric>): CountsByAppUserTypeMetric {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userAccountCount = 0;
        message.serviceAccountCount = 0;
        message.systemAccountCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CountsByAppUserTypeMetric>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountsByAppUserTypeMetric): CountsByAppUserTypeMetric {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user_account_count */ 1:
                    message.userAccountCount = reader.int64().toNumber();
                    break;
                case /* int64 service_account_count */ 2:
                    message.serviceAccountCount = reader.int64().toNumber();
                    break;
                case /* int64 system_account_count */ 3:
                    message.systemAccountCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountsByAppUserTypeMetric, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 user_account_count = 1; */
        if (message.userAccountCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.userAccountCount);
        /* int64 service_account_count = 2; */
        if (message.serviceAccountCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.serviceAccountCount);
        /* int64 system_account_count = 3; */
        if (message.systemAccountCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.systemAccountCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.CountsByAppUserTypeMetric
 */
export const CountsByAppUserTypeMetric = new CountsByAppUserTypeMetric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class YearInReviewMetricEntry$Type extends MessageType<YearInReviewMetricEntry> {
    constructor() {
        super("c1.api.metrics.v1.YearInReviewMetricEntry", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "int_value", kind: "scalar", oneof: "value", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<YearInReviewMetricEntry>): YearInReviewMetricEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<YearInReviewMetricEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: YearInReviewMetricEntry): YearInReviewMetricEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* int64 int_value */ 2:
                    message.value = {
                        oneofKind: "intValue",
                        intValue: reader.int64().toNumber()
                    };
                    break;
                case /* string string_value */ 3:
                    message.value = {
                        oneofKind: "stringValue",
                        stringValue: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: YearInReviewMetricEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* int64 int_value = 2; */
        if (message.value.oneofKind === "intValue")
            writer.tag(2, WireType.Varint).int64(message.value.intValue);
        /* string string_value = 3; */
        if (message.value.oneofKind === "stringValue")
            writer.tag(3, WireType.LengthDelimited).string(message.value.stringValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.YearInReviewMetricEntry
 */
export const YearInReviewMetricEntry = new YearInReviewMetricEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetYearInReviewRequest$Type extends MessageType<GetYearInReviewRequest> {
    constructor() {
        super("c1.api.metrics.v1.GetYearInReviewRequest", [
            { no: 1, name: "year", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "4", maxLen: "4" } } } }
        ]);
    }
    create(value?: PartialMessage<GetYearInReviewRequest>): GetYearInReviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.year = "";
        if (value !== undefined)
            reflectionMergePartial<GetYearInReviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetYearInReviewRequest): GetYearInReviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string year */ 1:
                    message.year = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetYearInReviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string year = 1; */
        if (message.year !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.year);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.GetYearInReviewRequest
 */
export const GetYearInReviewRequest = new GetYearInReviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetYearInReviewResponse$Type extends MessageType<GetYearInReviewResponse> {
    constructor() {
        super("c1.api.metrics.v1.GetYearInReviewResponse", [
            { no: 1, name: "metrics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => YearInReviewMetricEntry }
        ]);
    }
    create(value?: PartialMessage<GetYearInReviewResponse>): GetYearInReviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metrics = [];
        if (value !== undefined)
            reflectionMergePartial<GetYearInReviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetYearInReviewResponse): GetYearInReviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.metrics.v1.YearInReviewMetricEntry metrics */ 1:
                    message.metrics.push(YearInReviewMetricEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetYearInReviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.metrics.v1.YearInReviewMetricEntry metrics = 1; */
        for (let i = 0; i < message.metrics.length; i++)
            YearInReviewMetricEntry.internalBinaryWrite(message.metrics[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.metrics.v1.GetYearInReviewResponse
 */
export const GetYearInReviewResponse = new GetYearInReviewResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.metrics.v1.MetricsService
 */
export const MetricsService = new ServiceType("c1.api.metrics.v1.MetricsService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: MetricsServiceGetRequest, O: MetricsServiceGetResponse },
    { name: "GetYearInReview", options: { "authz.method": { role: "VIEWER" } }, I: GetYearInReviewRequest, O: GetYearInReviewResponse }
]);
